module.exports = __webpack_public_path__ + "static/media/pin_infra.51527313.png";